import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, type PropType } from "vue";
import { hasTouch } from "../../../../shared/device/has-touch";
import MediaGallery from "./media-gallery.vue";
import ModalComponent from "../../header/appearance-containers/modal/modal.vue";
import { type MediaItem } from "./types";


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaGalleryMain',
  props: {
    value: {
        type: Array as PropType<MediaItem[]>,
        required: true,
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
    vertical: {
        type: Boolean,
        default: false,
    },
    mediaGalleryClass: {
        type: [String, Object, Array],
    },
},
  setup(__props) {

const props = __props;

const expandEnabled = ref(!hasTouch());
const expanded = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MediaGallery, {
      value: __props.value,
      "full-width": __props.fullWidth,
      vertical: __props.vertical,
      onExpand: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = true)),
      "has-another-view-open": expanded.value,
      "expand-enabled": expandEnabled.value,
      class: _normalizeClass(__props.mediaGalleryClass)
    }, _createSlots({ _: 2 /* DYNAMIC */ }, [
      _renderList(_ctx.$slots, (index, name) => {
        return {
          name: name,
          fn: _withCtx((data) => [
            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
          ])
        }
      })
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "full-width", "vertical", "has-another-view-open", "expand-enabled", "class"]),
    (expandEnabled.value)
      ? (_openBlock(), _createBlock(ModalComponent, {
          key: 0,
          modelValue: expanded.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((expanded).value = $event)),
          "content-class": _ctx.$style['gallery-modal-view']
        }, {
          default: _withCtx(() => [
            _createVNode(MediaGallery, {
              value: __props.value,
              "disable-expand": "",
              "full-width": "",
              "show-arrows": "",
              "enable-arrow-keys": expanded.value,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = false))
            }, null, 8 /* PROPS */, ["value", "enable-arrow-keys"])
          ], undefined, true),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "content-class"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})